module.exports = __webpack_public_path__ + "img/9788991931589.22552987.jpg";